var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtractImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.15 162.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.17,68.42a16,16,0,1,0-16-16A16,16,0,0,0,114.17,68.42Zm0-24a8,8,0,1,1-8,8h0A8,8,0,0,1,114.17,44.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.08,
    y: 31.92,
    width: 8.56,
    height: 97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,148.92a10,10,0,0,1-8.44,4.68H18.53a10,10,0,0,1-10-10V18.53a10,10,0,0,1,10-10H175.1a9.91,9.91,0,0,1,7.45,3.36h9.84A18.54,18.54,0,0,0,175.1,0H18.53A18.55,18.55,0,0,0,0,18.53V143.62a18.55,18.55,0,0,0,18.53,18.53H175.1a18.56,18.56,0,0,0,17.75-13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,130.34a2.75,2.75,0,0,0-2.73,2.77v2.77H248a2.77,2.77,0,0,0,0,5.54h5.46a2.75,2.75,0,0,0,2.72-2.77v-5.54a2.75,2.75,0,0,0-2.72-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,135.88H160.7a2.77,2.77,0,0,0-.06,5.54h11a2.77,2.77,0,0,0,.06-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.43,135.88H182.52a2.77,2.77,0,0,0,0,5.54h10.91a2.77,2.77,0,0,0,0-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,135.88H117.06a2.77,2.77,0,0,0-.06,5.54h11a2.77,2.77,0,0,0,.06-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,135.88H95.24a2.77,2.77,0,0,0-.06,5.54h11a2.77,2.77,0,0,0,.06-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.24,135.88h-10.9a2.77,2.77,0,0,0-.07,5.54h11a2.77,2.77,0,0,0,.07-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,135.88H138.88a2.77,2.77,0,0,0,0,5.54h10.91a2.77,2.77,0,0,0,0-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,135.88H226.15a2.77,2.77,0,0,0-.06,5.54h11a2.77,2.77,0,0,0,.06-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,135.88H81.61v-2.77a2.73,2.73,0,1,0-5.46-.06v5.6a2.75,2.75,0,0,0,2.73,2.77h5.46a2.77,2.77,0,0,0,0-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,77.86A2.78,2.78,0,0,0,81.61,75h0V63a2.73,2.73,0,1,0-5.46,0V75a2.78,2.78,0,0,0,2.73,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,54a2.75,2.75,0,0,0,2.73-2.77V39.56a2.73,2.73,0,1,0-5.46-.06V51.25A2.75,2.75,0,0,0,78.88,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,100.8A2.75,2.75,0,0,0,81.61,98V86.34a2.73,2.73,0,1,0-5.46,0V98A2.75,2.75,0,0,0,78.88,100.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.88,124.19a2.75,2.75,0,0,0,2.73-2.77v-11.7a2.73,2.73,0,1,0-5.46-.06v11.76a2.75,2.75,0,0,0,2.73,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,19.56H78.88a2.75,2.75,0,0,0-2.73,2.77h0v5.54a2.73,2.73,0,1,0,5.46,0V25.1h2.73a2.77,2.77,0,0,0,0-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,25.1h10.91a2.77,2.77,0,0,0,.07-5.54h-11a2.77,2.77,0,0,0-.06,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.06,25.1H128a2.77,2.77,0,0,0,.06-5.54h-11A2.77,2.77,0,0,0,117,25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.34,25.1h10.9a2.77,2.77,0,0,0,.07-5.54h-11a2.77,2.77,0,0,0-.07,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7,25.1h10.91a2.77,2.77,0,0,0,.06-5.54h-11a2.77,2.77,0,0,0-.06,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,25.1h10.91a2.77,2.77,0,0,0,0-5.54H182.52a2.77,2.77,0,0,0,0,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.06,19.56H226.15a2.77,2.77,0,0,0-.06,5.54h11a2.77,2.77,0,0,0,.07-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.88,25.1h10.91a2.77,2.77,0,0,0,0-5.54H138.88a2.77,2.77,0,0,0,0,5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,19.56H248a2.77,2.77,0,0,0,0,5.54h2.73v2.77a2.73,2.73,0,1,0,5.45,0V22.33A2.75,2.75,0,0,0,253.43,19.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,36.79a2.75,2.75,0,0,0-2.73,2.77h0V51.25a2.73,2.73,0,1,0,5.45.07V39.56A2.75,2.75,0,0,0,253.43,36.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,83.57a2.75,2.75,0,0,0-2.73,2.77V98a2.73,2.73,0,1,0,5.45.06V86.34a2.75,2.75,0,0,0-2.72-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,107a2.75,2.75,0,0,0-2.73,2.77v11.69a2.73,2.73,0,1,0,5.45,0v-11.7A2.74,2.74,0,0,0,253.43,107Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,60.18A2.75,2.75,0,0,0,250.7,63V74.64a2.73,2.73,0,1,0,5.45,0V63a2.75,2.75,0,0,0-2.72-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.19,114.8H41.38l22.67-33,5.14,3.42V75.62l-.61-.4.61-.88V60.22l-38.7,56.32a4,4,0,0,0,1,5.56,4.08,4.08,0,0,0,2.27.7h35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,116.29,130.55,76.13a4,4,0,0,0-5.62-.61,3.85,3.85,0,0,0-.6.61L113.52,89.52,89.19,60.66v12.4l1.16,1.38-1.16.69v9.31l6.38-3.81,12.84,15.22-15.29,19H89.19v8h70.66a4,4,0,0,0,3.11-6.51ZM127.44,85l6.75,8.36L131,96.72l-7-7.43Zm-24,29.8,15.52-19.23,9.09,9.69a4,4,0,0,0,2.89,1.26h0a4,4,0,0,0,2.87-1.23l5.46-5.66,12.24,15.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractImage);
export default __webpack_public_path__ + "static/media/extractImage.b9ded8d20d8ab495758b6f5feb561b63.svg";
export { ForwardRef as ReactComponent };